import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, NavigationExtras } from '@angular/router';

import { AngularMenuItem } from '../models';
import { AngularAppConfig } from '../functions';

@Injectable()
export class NavigationService {
    paginaCorrente: string;
    requestedItem: AngularMenuItem = null;

    constructor(private router: Router, private location: Location) {
        this.router.events
            .filter(a => a instanceof NavigationEnd)
            .subscribe(x => this.handleBreadCrumb(x as any));
    }

    handleBreadCrumb(e: any) {
        // let nextUrl: string = e.url.split("/").filter(x => x && x.trim() != "")[0];
        let url = e.url as string;
        let nextUrl: string = url.indexOf("/") == 0 ? url.substr(1, url.length) : url;
        let listaBreadcrumbs: AngularMenuItem[] = this.getBreadcrumbItems();
        if(!listaBreadcrumbs) listaBreadcrumbs = new Array<AngularMenuItem>();

        let itemPosition: number = null;
        let breadcrumbFound: boolean = false;
        let itemCount = listaBreadcrumbs.length;
        for (let i = 0; i < itemCount; i++) {
            if (nextUrl == listaBreadcrumbs[i].action) {
                this.requestedItem = listaBreadcrumbs[i];
                itemPosition = i;
                breadcrumbFound = true;
                break;
            }
        }
        
        if (breadcrumbFound) listaBreadcrumbs.splice(itemPosition, itemCount - itemPosition);
        
        if (this.requestedItem) {
            this.paginaCorrente = this.requestedItem.action;
            AngularAppConfig.setFunzioneCorrente(this.requestedItem.funzione);
            listaBreadcrumbs.push(this.requestedItem);
            if (this.paginaCorrente == 'index') listaBreadcrumbs = new Array<AngularMenuItem>();
            this.requestedItem = null;
        }
        else listaBreadcrumbs = new Array<AngularMenuItem>();
        
        AngularAppConfig.setJsonTag("breadcrumbs", listaBreadcrumbs);
        window.scrollTo(0, 0);
    }

    setItem(action: string, funzione: string, param: any): AngularMenuItem {
        let item: AngularMenuItem = new AngularMenuItem();
        item.action = action;
        item.funzione = funzione;
        if (param && param != null) item.param = param;
        return item;
    }

    navigate(action: string, funzione: string, param: any): void {
        this.navigateItem(this.setItem(action, funzione, param));
    }

    menuNavigate(item: AngularMenuItem) {
        AngularAppConfig.setJsonTag("breadcrumbs", new Array<AngularMenuItem>());
        this.navigateItem(item);
    }

    navigateItem(item: AngularMenuItem): void {
        let navigateUrl: string[] = new Array<string>();
        this.requestedItem = item;
        navigateUrl[0] = item.action;
        if (item.param) this.router.navigate(["/" + navigateUrl, item.param]);
        else this.router.navigate(navigateUrl);
    }

    navigateNoHistory(action: string, funzione: string, param: any, extras: NavigationExtras): void {
        let item: AngularMenuItem = this.setItem(action, funzione, param);
        let navigateUrl: string[] = new Array<string>();
        this.requestedItem = item;
        navigateUrl[0] = item.action;
        
        if (item.param) this.router.navigate(["/" + navigateUrl, item.param], extras);
        else this.router.navigate(navigateUrl, extras);
    }

    getPaginaCorrente(): string {
        return this.paginaCorrente;
    }

    getBreadcrumbItems(): AngularMenuItem[] {
        return AngularAppConfig.getJsonTag("breadcrumbs");
    }
}




// WEBPACK FOOTER //
// ./src/angular_library/services/navigation.service.ts